module.exports = __webpack_public_path__ + "static/media/50.03fc48a0.jpg";